var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadFileLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 8.3125V6.78125C11.375 6.2591 11.1676 5.75835 10.7984 5.38913C10.4292 5.01992 9.92839 4.8125 9.40625 4.8125H8.53125C8.3572 4.8125 8.19028 4.74336 8.06721 4.62029C7.94414 4.49722 7.875 4.3303 7.875 4.15625V3.28125C7.875 2.7591 7.66758 2.25835 7.29837 1.88913C6.92915 1.51992 6.42839 1.3125 5.90625 1.3125H4.8125M5.25 8.3125L7 10.0625M7 10.0625L8.75 8.3125M7 10.0625V6.5625M6.125 1.3125H3.28125C2.919 1.3125 2.625 1.6065 2.625 1.96875V12.0312C2.625 12.3935 2.919 12.6875 3.28125 12.6875H10.7187C11.081 12.6875 11.375 12.3935 11.375 12.0312V6.5625C11.375 5.17011 10.8219 3.83476 9.83731 2.85019C8.85274 1.86562 7.51739 1.3125 6.125 1.3125Z",
    stroke: "#333333",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFileLine);
export default __webpack_public_path__ + "static/media/DownloadFileLine.d466316d2aad49dc17edd1246ba238e1.svg";
export { ForwardRef as ReactComponent };